/**
 * @Desription: 登录-配置管理
 * @Author: netstar.sjj
 * @Date: 2021-10-25 16:05:00
 * @class configManager
*/
declare const window:any;
namespace configManager{
    export function setDefault(config:any){
        config.$login = window.jQuery(config.submitBtnEl).closest('.login');
        let staticRootPath:string = '';//默认的静态资源路径
        switch(config.userMode){
            case 'user':
                //用户模式
                staticRootPath = config.rootPath + 'dist/';
                break;
            case 'dev':
                //开发模式
                staticRootPath = config.rootPath + 'assets/';
                break;
        }
        config.staticRootPath = staticRootPath;
    }
}
export default configManager;